// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"kX-z","inlineTitle":"lX-z","sponsoredAdsWrapper":"mX-z","marketplaceRecosWrapper":"nX-z"};